import React, { Component } from 'react';
import styled, { css } from 'styled-components';

import Container from 'partials/Container';
import Html from 'partials/Html';
import GridElement from 'partials/GridElement';

class RichText extends Component {

    convertPhonenumbersToHyperlinks = (content) => {
        if (!content) return;
        var urlRegex = /(\+\d{1,3}\s?)?((\(\d{3}\)\s?)|(\d{2})(\s|-?))(\d{2}(\s|-?))(\d{2}(\s|-?))(\d{2})(\s?(([E|e]xt[:|.|]?)|x|X)(\s?\d+))?/;
        return content.replace(urlRegex, function (phonenumber) {
            return (
                '<a href="tel:' +
                phonenumber +
                '">' +
                phonenumber +
                '</a>'
            );
        });
    }

    render() {
        const { data, prevModule } = this.props;

        return (
            <ModuleWrapper prevModule={prevModule}>
                <Container grid>
                    <GridElement
                        colStart={{default: 1, s: 7}}
                        colEnd={{default: 8, s: 18}}
                    >
                        <StyledHtml content>{this.convertPhonenumbersToHyperlinks(data.content)}</StyledHtml>
                    </GridElement>
                </Container>
            </ModuleWrapper>
        );
    }
}

export default RichText;

const ModuleWrapper = styled.section`
    ${props => props.prevModule === 'rich_text' && css`
        margin-top: ${props => props.theme.spacing.elementXS};
    `}
`

const StyledHtml = styled(Html)`
    width: 100%;
    h1 {
        font-weight: 400;
    }
`